"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapComponent = void 0;
const config_1 = __importDefault(require("@arcgis/core/config"));
const Handles_1 = __importDefault(require("@arcgis/core/core/Handles"));
const Extent_1 = __importDefault(require("@arcgis/core/geometry/Extent"));
const SpatialReference_1 = __importDefault(require("@arcgis/core/geometry/SpatialReference"));
const FeatureLayer_1 = __importDefault(require("@arcgis/core/layers/FeatureLayer"));
const Map_1 = __importDefault(require("@arcgis/core/Map"));
const UniqueValueRenderer_1 = __importDefault(require("@arcgis/core/renderers/UniqueValueRenderer"));
const MapView_1 = __importDefault(require("@arcgis/core/views/MapView"));
const Print_1 = __importDefault(require("@arcgis/core/widgets/Print"));
const SizeVariable_1 = __importDefault(require("@arcgis/core/renderers/visualVariables/SizeVariable"));
const Expand_1 = __importDefault(require("@arcgis/core/widgets/Expand"));
const Legend_1 = __importDefault(require("@arcgis/core/widgets/Legend"));
const SketchWidget_1 = require("../Sketch/SketchWidget");
const UniqueValueInfos_1 = require("../Symbology/UniqueValueInfos");
const SimpleLineSymbol_1 = __importDefault(require("@arcgis/core/symbols/SimpleLineSymbol"));
const SimpleMarkerSymbol_1 = __importDefault(require("@arcgis/core/symbols/SimpleMarkerSymbol"));
class MapComponent {
    constructor(mapComponentObject) {
        this.view = new MapView_1.default();
        this.zoom = (layer, ids) => {
            let query = layer.createQuery();
            query.objectIds = ids;
            query.returnGeometry = true;
            console.log('QUERY');
            layer.queryFeatures(query).then((response) => {
                var _a;
                console.log('BEFORE VIEW GOTO');
                (_a = this.view) === null || _a === void 0 ? void 0 : _a.goTo(response.features).catch((error) => {
                    if (error.name !== 'AbortError') {
                        console.error(error);
                    }
                });
            });
        };
        this.zoomBbox = (bbox) => {
            const extent = new Extent_1.default({
                xmin: bbox.xmin,
                ymin: bbox.ymin,
                xmax: bbox.xmax,
                ymax: bbox.ymax,
                spatialReference: new SpatialReference_1.default({ wkid: bbox.wkid }),
            });
            this.view.extent = extent;
        };
        this.selectFeature = (graphic) => {
            this.selectedFeature = graphic;
            const { selectCallback } = this.mapComponentObject;
            selectCallback(this.selectedFeature);
            if (graphic.layer instanceof FeatureLayer_1.default)
                this.view
                    .whenLayerView(graphic.layer)
                    .then((layerView) => {
                    if (this.highlightSelect) {
                        this.highlightSelect.remove();
                    }
                    // use the objectID to highlight the feature
                    this.highlightSelect.add(layerView.highlight(graphic));
                });
        };
        this.clearSelection = () => {
            this.selectedFeature = undefined;
            if (this.highlightSelect) {
                this.highlightSelect.remove();
            }
        };
        this.mapComponentObject = mapComponentObject;
        this.highlightSelect = new Handles_1.default();
    }
    launch() {
        this.createMap();
        this.addLayers();
    }
    createMap() {
        const { basemap, container, bbox, minZoom, maxZoom, updateCallback, addCallback, } = this.mapComponentObject;
        const map = new Map_1.default({
            basemap: basemap,
        });
        this.view = new MapView_1.default({
            container: container,
            map: map,
            highlightOptions: {
                fillOpacity: 0,
                color: [50, 50, 50],
            },
            constraints: {},
            popup: {
                collapseEnabled: false,
            },
        });
        if (bbox) {
            this.zoomBbox(bbox);
        }
        if (minZoom) {
            this.view.constraints.minZoom = minZoom;
        }
        if (maxZoom) {
            this.view.constraints.maxZoom = maxZoom;
        }
        // Event handler that fires each time an action is clicked.
        /* this.view.popup.on("trigger-action", (event) => {
            let feature = this.view.popup.selectedFeature;
            switch (event.action.id) {
                case "edit-action":
                    console.log("edit-action", feature);

                    break;
                default:
                    break;
            }
        }); */
        this.sketchWidget = new SketchWidget_1.SketchWidget({
            view: this.view,
            updateCallback: updateCallback,
            addCallback: addCallback,
        });
        //this.view.ui.add(this.sketchWidget.getSketchWidget(), "top-right");
        this.view.when(() => {
            this.view.ui.add([
                new Expand_1.default({
                    view: this.view,
                    content: new Legend_1.default({
                        view: this.view,
                        respectLayerVisibility: false,
                    }),
                    group: 'top-left',
                    expanded: false,
                }),
            ], 'top-left');
            if (this.mapComponentObject.showPrint) {
                // Adds widget below other elements in the top left corner of the view
                this.view.ui.add(new Expand_1.default({
                    content: new Print_1.default({
                        view: this.view,
                        templateOptions: {
                            legendEnabled: false,
                        },
                        // specify your own print service
                        printServiceUrl: 'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                    }),
                    view: this.view,
                }), 'top-left');
            }
            /* this.view.watch('scale', (event) => {
                if (!event) return;

                console.log('Scale', event);
            }); */
            // Get the screen point from the view's click event
            this.view.on('click', (event) => {
                this.clearSelection();
                if (this.mapComponentObject.publicView) {
                    return;
                }
                // Search for graphics at the clicked location. this.View events can be used
                // as screen locations as they expose an x,y coordinate that conforms
                // to the ScreenPoint definition.
                this.view.hitTest(event).then((response) => {
                    var _a, _b, _c;
                    if (((_a = response.results) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        console.log('response.results', response.results);
                        // only get the graphics returned from myLayer
                        const nodeHit = (_b = response.results) === null || _b === void 0 ? void 0 : _b.filter((hitResult) => hitResult.type === 'graphic' &&
                            hitResult.graphic.layer ===
                                this.nodeFeatureLayer);
                        if (nodeHit.length > 0 &&
                            nodeHit[0].type === 'graphic') {
                            this.selectFeature(nodeHit[0].graphic);
                            if (this.selectedFeature)
                                this.sketchWidget.updateFeature(this.selectedFeature);
                        }
                        else {
                            // only get the graphics returned from myLayer
                            const edgeHit = (_c = response.results) === null || _c === void 0 ? void 0 : _c.filter((hitResult) => hitResult.type === 'graphic' &&
                                hitResult.graphic.layer ===
                                    this.edgeFeatureLayer);
                            if (edgeHit.length > 0 &&
                                edgeHit[0].type === 'graphic') {
                                this.selectFeature(edgeHit[0].graphic);
                                if (this.selectedFeature)
                                    this.sketchWidget.updateFeature(this.selectedFeature);
                            }
                        }
                    }
                });
            });
        });
    }
    refreshLayers() {
        this.edgeFeatureLayer.refresh();
        this.nodeFeatureLayer.refresh();
    }
    addLayers() {
        const { edgeLayer, nodeLayer, token } = this.mapComponentObject;
        this.edgeFeatureLayer = this.createFeatureLayer(edgeLayer, token);
        this.edgeFeatureLayer.renderer = new UniqueValueRenderer_1.default({
            field: 'Symbol',
            uniqueValueInfos: UniqueValueInfos_1.edgeUniqueValueInfo,
            defaultSymbol: new SimpleLineSymbol_1.default({
            /* style: "solid",
            color: [130, 130, 130, 255],
            width: 1,*/
            }),
            defaultLabel: 'Not defined',
            visualVariables: [
                new SizeVariable_1.default({
                    // resizable
                    valueExpression: '$view.scale',
                    stops: [
                        /*   { value: 1128, size: 5 },
                          { value: 288895, size: 4 },
                          { value: 577790, size: 3 },
                          { value: 2311162, size: 2 },
                          { value: 4622324, size: 1.5 }, */
                        { value: 18489297, size: 1 },
                    ],
                }),
            ],
        });
        this.nodeFeatureLayer = this.createFeatureLayer(nodeLayer, token);
        this.nodeFeatureLayer.renderer = new UniqueValueRenderer_1.default({
            field: 'Symbol',
            uniqueValueInfos: UniqueValueInfos_1.nodeUniqueValueInfo,
            defaultSymbol: new SimpleMarkerSymbol_1.default(),
            defaultLabel: 'Not defined',
            //symbol changed size when zoom in zoom out
            visualVariables: [
                new SizeVariable_1.default({
                    // resizable icons
                    valueExpression: '$view.scale',
                    stops: [
                        { size: 1.0, value: 591657527 },
                        { size: 1.25, value: 147914381.8 },
                        { size: 2.5, value: 36978595.44 },
                        { size: 5.0, value: 9244648.859 },
                        { size: 10.0, value: 2311162.215 },
                        /*  { size: 20.0,   value: 577790.5537 },
                         { size: 40.0,   value: 144447.6384 },
                         { size: 80.0,   value: 36111.90961 },
                         { size: 160.0,  value: 9027.977402 },
                         { size: 320.0,  value: 2256.99435 }, */
                    ],
                }),
            ],
        });
        this.view.map.addMany([this.edgeFeatureLayer, this.nodeFeatureLayer]);
    }
    createFeatureLayer(layerObject, token) {
        var _a, _b;
        const lyr = new FeatureLayer_1.default({
            url: `${layerObject.layerUrl}`,
            outFields: ['*'],
        });
        if (layerObject.title) {
            lyr.title = layerObject.title;
        }
        if (layerObject.definitionExpression) {
            lyr.definitionExpression = layerObject.definitionExpression;
        }
        if (layerObject.minScale) {
            lyr.minScale = layerObject.minScale;
        }
        if (layerObject.maxScale) {
            lyr.maxScale = layerObject.maxScale;
        }
        (_b = (_a = config_1.default === null || config_1.default === void 0 ? void 0 : config_1.default.request) === null || _a === void 0 ? void 0 : _a.interceptors) === null || _b === void 0 ? void 0 : _b.push({
            // set the `urls` property to the URL of the FeatureLayer so that this
            // interceptor only applies to requests made to the FeatureLayer URL
            urls: lyr.url,
            // use the BeforeInterceptorCallback to add token to query
            before: (params) => {
                params.requestOptions.query = params.requestOptions.query || {};
                params.requestOptions.query.token =
                    this.mapComponentObject.token;
            },
            error: (error) => {
                if (error.details.httpStatus === 498) {
                    this.mapComponentObject.errorCallback();
                }
            },
        });
        this.view.whenLayerView(lyr).then((layerView) => {
            const { publicView } = this.mapComponentObject;
            if (publicView && !lyr.popupTemplate) {
                const popupTemplate = lyr.createPopupTemplate();
                lyr.popupTemplate = popupTemplate;
                this.removeLayerNamePopup(lyr);
                lyr.popupTemplate.fieldInfos = [];
                this.view.popup.collapseEnabled = false;
            }
            /* const popupTemplate = lyr.createPopupTemplate();
            lyr.popupTemplate = popupTemplate;
            lyr.popupTemplate.content = []; */
            /* let emergencyLinkExternalToAction = new ActionButton({
                title: "Edit",
                id: "edit-action",
                className: "esri-icon-link-external",
            });

            let actionsCollection = new Collection([
                emergencyLinkExternalToAction,
            ]);
            // actionsCollection.add(emergencyLinkExternalToAction);

            lyr.popupTemplate.actions = actionsCollection; */
        });
        return lyr;
    }
    removeLayerNamePopup(layer) {
        const layerTitle = layer.title;
        let popupTemplateTitle = layer.popupTemplate.title;
        if (typeof popupTemplateTitle === 'string') {
            let newPopupTitle = popupTemplateTitle
                .split(`${layerTitle}:`)
                .pop();
            if (newPopupTitle) {
                layer.popupTemplate.title = newPopupTitle.trim();
            }
        }
    }
    refreshToken(token) {
        this.mapComponentObject.token = token;
    }
    getFeatureAsync(id, layer) {
        let query = layer.createQuery();
        query.objectIds = [id];
        query.returnGeometry = true;
        return this.view.whenLayerView(layer).then((layerView) => {
            return layerView.queryFeatures(query);
        });
        //layer.queryFeatures(query);
    }
}
exports.MapComponent = MapComponent;
